import React from 'react';
import FloorDropDown from '../../../../common/UnitMap/FloorDropDown';
import UnitMap from '../../../../common/UnitMap/UnitMap';

const { useRef, useState, useEffect } = React;

function StickyUnitMap() {
    let apiKey = process.env.REACT_APP_UNITMAP_API_KEY;
    //https://stackoverflow.com/questions/16302483/event-to-detect-when-positionsticky-is-triggered?noredirect=1&lq=1
    const [isSticky, setIsSticky] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const cachedRef = ref.current,
            //https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API for reference
            observer = new IntersectionObserver(([e]) => setIsSticky(e.intersectionRatio < 1), {
                //detect only intersection on top of screen - this is a bounding box with these offsets
                rootMargin: '-1px 10000px 10000px 10000px',
                threshold: [1]
            });

        observer.observe(cachedRef as any);

        // unmount
        return function () {
            observer.unobserve(cachedRef as any);
        };
    }, []);
    return (
        <div
            ref={ref}
            className={`sticky-top configuration-wrapper p-2${isSticky ? ' isSticky' : ''}`}
        >
            {apiKey ? <UnitMap apiKey={apiKey} /> : <h2>No API Key configured</h2>}
            <FloorDropDown />
        </div>
    );
}

export default StickyUnitMap;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/StickyUnitMap.tsx